import { render, staticRenderFns } from "./_base-expandable-view.vue?vue&type=template&id=4305e9a4&"
import script from "./_base-expandable-view.vue?vue&type=script&lang=js&"
export * from "./_base-expandable-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports